import { useStyledTheme } from '@openeducation/oe-rn-themes';
import React from 'react';
import { StyleSheet, View } from 'react-native';

interface FeedbackResponseProps {
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

function FeedbackResponse({ icon, children }: FeedbackResponseProps) {
  const { color } = useStyledTheme();

  return (
    <View style={[styles.container, { backgroundColor: color.grayLight }]}>
      <View style={styles.innerContainer}>
        <View style={styles.textIconContainer}>
          {icon && (
            <View
              style={[styles.iconBubble, { backgroundColor: color.background }]}
            >
              {icon}
            </View>
          )}
          {children}
        </View>
      </View>
    </View>
  );
}

export default FeedbackResponse;

const styles = StyleSheet.create({
  container: {
    paddingVertical: 32,
    paddingHorizontal: 42,
    flex: 1,
  },
  innerContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textIconContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconBubble: {
    width: 80,
    height: 80,
    borderRadius: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
